export default __webpack_public_path__ + "img/1836b7927c99458dbfacb50056ea6749.svg";